var _defs, _rect, _rect2, _line, _line2, _line3, _line4, _polyline, _rect3, _line5, _line6, _polyline2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 157 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b3ddee;}.cls-1,.cls-2,.cls-4,.cls-5{stroke:#0090b9;}.cls-1,.cls-2,.cls-5{stroke-miterlimit:10;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke-width:2px;}.cls-2{fill:#fff;}.cls-3,.cls-4,.cls-5{fill:none;}.cls-3{stroke:#b3ddee;}.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.64,
    y: 107.94,
    width: 24.15,
    height: 20.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.64,
    y: 71.22,
    width: 24.15,
    height: 20.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.22,
    y1: 75.9,
    x2: 110.23,
    y2: 75.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.22,
    y1: 86.67,
    x2: 110.23,
    y2: 86.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.22,
    y1: 112.58,
    x2: 110.23,
    y2: 112.58
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.22,
    y1: 123.35,
    x2: 110.23,
    y2: 123.35
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "52.84 118.89 55.82 122.62 64.03 112.93"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45.64,
    y: 35.94,
    width: 24.15,
    height: 20.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.22,
    y1: 40.58,
    x2: 110.23,
    y2: 40.58
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.22,
    y1: 51.35,
    x2: 110.23,
    y2: 51.35
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "52.84 46.89 55.82 50.62 64.03 40.93"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 77.35,
    cy: 81.33,
    r: 66.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.9592070c96317d26a374f812df8ea1cc.svg";
export { ForwardRef as ReactComponent };